import { useState } from 'react'
import { IProfileUser } from 'types'
import Avatar from '../avatar'
import { onError, onSuccess, useDeleteUserField, useEditUserForm } from '../hooks/edit-field'

type Props = {
    user: IProfileUser
    showDelete?: boolean
    avatarSize?: number
    onAvatarError: onError
    onAvatarSuccess: onSuccess
    onAvatarChangeClick?: () => void
}

const defaultAvatar = 'https://media.giphy.com/avatars/default5.gif'
const AvatarUpload = ({
    user,
    showDelete = true,
    avatarSize,
    onAvatarError,
    onAvatarSuccess,
    onAvatarChangeClick,
}: Props) => {
    const [avatar, setAvatar] = useState<string>(user.avatar_url || defaultAvatar)
    const [hasDefaultAvatar, setHasDefaultAvatar] = useState<boolean>(user.has_default_avatar)
    const [isSaving, setSavingForm, formRef] = useEditUserForm(user.id, onAvatarSuccess, onAvatarError)
    const onAvatarDelete = (message: string) => {
        setAvatar(defaultAvatar)
        setHasDefaultAvatar(true)
        onAvatarSuccess(message)
    }
    const onAvatarAccepted = (isValid: boolean, preview: string) => {
        setSavingForm(isValid)
        if (isValid && preview) {
            setHasDefaultAvatar(false)
            setAvatar(preview)
        }
    }
    const onAvatarDeleteClick = () => {
        // simple confirm for now.
        if (window.confirm(`Are you sure you want to delete your avatar?`)) {
            setDeleteAvatar(true)
        }
    }
    const [isDeleteingAvatar, setDeleteAvatar] = useDeleteUserField(user.id, 'avatar', onAvatarDelete, onAvatarError)
    return (
        <form ref={formRef}>
            <Avatar
                avatarSize={avatarSize}
                userAvatar={avatar}
                onValid={onAvatarAccepted}
                isDeleting={isDeleteingAvatar}
                isSaving={isSaving}
                onError={onAvatarError}
                showDelete={showDelete ? !hasDefaultAvatar : false}
                onDelete={onAvatarDeleteClick}
                onChangeClick={onAvatarChangeClick}
            />
        </form>
    )
}

export default AvatarUpload
